import { Navigate, type RouteObject } from 'react-router';
import { GuestLocationDetailsLayout } from '../layouts/GuestLocationDetailsLayout';
import GuestLocationFormApi from '../components/location-form/GuestLocationFormApi';
import { GuestLocationBalanceTab } from '../components/location-balance-tab/GuestLocationBalanceTab';
import { GuestLocationAssetsTab } from '../components/location-assets-tab/GuestLocationAssetsTab';
import { GuestLocationMovementsTab } from '../components/location-movements-tab/GuestLocationMovementsTab';
import GuestLocationsPage from '../pages/GuestLocationsPage';

export const GUEST_LOCATION_ROUTES: RouteObject[] = [
  {
    path: 'guest-locations',
    children: [
      {
        index: true,
        element: <GuestLocationsPage />,
      },
    ],
  },
  {
    path: 'guest-locations/:locationId',
    element: <GuestLocationDetailsLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: 'movements',
        element: <GuestLocationMovementsTab />,
      },
      {
        path: 'details',
        element: <GuestLocationFormApi />,
      },
      {
        path: 'balance',
        element: <GuestLocationBalanceTab />,
      },
      {
        path: 'assets',
        element: <GuestLocationAssetsTab />,
      },
    ],
  },
];
